import * as React from 'react';
import { Row, Col, Button } from 'antd';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { TextView } from 'src/core/ui/text.view';
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	selectedMarketId?: number;
	onChangeMarket: (newMarket: MarketSummary) => void;
	onClickCalculatePrices: () => Promise<void>;
}

@observer
export class TourItineraryDateMarketConfig extends React.Component<Props, {}> {
	private static roundPolicyOptions: RoundPolicy[] = [
		{ value: 0, label: 'Round Up' },
		{ value: 1, label: 'Round Down' },
		{ value: 2, label: 'Exact value' }
	];

	render(): React.ReactNode {
		const { model, selectedMarketId, onChangeMarket, onClickCalculatePrices, mode, setBusy } = this.props;
		const marketsPrice: ItineraryDateMarketPrice[] = model.dynamicProperties.marketsPrice;
		const selectedMarket = marketsPrice.find(m => m.marketId === selectedMarketId);

		return (
			<Row gutter={16}>
				<Col xs={8}>
					<Row gutter={8}>
						<Col xs={24}>
							Market
						</Col>
						<Col xs={24}>
							<MarketEditorController
								required
								label={null}
								mode={mode}
								value={selectedMarketId}
								onChanged={(newValue) => {
									if (newValue != null) {
										onChangeMarket(newValue);
									}
								}}
								afterLoad={(_, options) => {
									if (selectedMarketId == null) {
										onChangeMarket(options[0]);
									}
								}}
								setBusy={setBusy}
							/>
						</Col>
					</Row>
				</Col>
				{
					selectedMarket != null &&
					<Col xs={8}>
						<Row gutter={8}>
							<Col xs={24}>
								Round policy (to nearest)
						</Col>
							<Col xs={8}>
								<TextView
									required
									label={null}
									mode={mode}
									targetType="int+"
									value={selectedMarket.roundPolicyValue}
									onChanged={(newValue) => {
										selectedMarket.roundPolicyValue = newValue;
									}}
								/>
							</Col>
							<Col xs={16}>
								<DropdownView
									required
									label={null}
									disabled={mode === 'display'}
									options={TourItineraryDateMarketConfig.roundPolicyOptions}
									keyField="value"
									textField="label"
									model={selectedMarket.roundPolicyType}
									onChanged={(newValue) => {
										if (newValue != null) {
											selectedMarket.roundPolicyType = newValue.value;
										}
									}}
								/>
							</Col>
						</Row>
					</Col>
				}
				<Col xs={24}>
					<Button
						type="primary"
						icon="reload"
						onClick={onClickCalculatePrices}
						disabled={mode === 'display'}>
						Calculate Prices
					</Button>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-market-config.tsx